//@flow

import {kind} from './index.h'

export const store: kind = 'store'
export const event: kind = 'event'
export const effect: kind = 'effect'
export const domain: kind = 'domain'
